import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; 
import Swal from "sweetalert2";
import { useNavigate, useLocation } from 'react-router-dom';

import "react-loading-skeleton/dist/skeleton.css";
import Select from "react-select";
import Mapping from '../pendidik/form/Maping.js';

const DaftarTesGuru = () => {
    const [pembelajaran, setPembelajaran] = useState([]); 
    const [ujianlist, setUjianList] = useState([]); 

    const location = useLocation(); // Gunakan useLocation untuk membaca query string
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    const [formData, setFormData] = useState({
        kode_mst:id,
        id_ujian: "",
        id_rombel: "",
        id_mapel: "",
        nama_mapel: "",
        nama_rombel: "",
        durasi: "",
        guru_id: "",
        nama_guru: "",
        status_hasil_guru:"1",
        pembelajaran_id:""

    }); // State untuk menyimpan daftar kelas
    const [isEditing, setIsEditing] = useState(false);
    const [soalmaping, setSoalMaping] = useState([]);

   
    const getDataRefrensi = async () => {
        
        
        try {
                 // Kirim request ke server dengan header level user
                 const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/getPembelajaranToUjian`, {
                     method: 'GET',
                    headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                 });
 
                 if (!response.ok) {
                     throw new Error("Failed to fetch kelas");
                 }
 
                 const data = await response.json();
                 
                 // Menyimpan data kelas ke dalam state
                 setPembelajaran(data.data); 
                 console.log(data.data);
             } catch (error) {
              
                 Swal.fire("Error!", error.message || 'Something went wrong', "error");
             }
     }

    useEffect(() => { 
        getDataRefrensi();
        console.log(localStorage.getItem('authToken'))
       
        if ($.fn.dataTable.isDataTable('.table-data')) {
            $('.table-data').DataTable().destroy();
        }
        
        $('.table-data').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/admin/refrensi/getUjian?id=${id}`,
                type: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                dataSrc: function(json) {
                    if (!json.data || json.data.length === 0) {
                        return []; // Jika data kosong, tetap kembalikan array kosong agar DataTables tetap berfungsi
                    }
                    return json.data;
                }
            },
            columns: [
                { 
                    data: null, 
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.id_ujian}</b>`;
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.nama_rombel} || ${data.nama_mapel}</b>`;
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.nama_guru}</b>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        let soalCount = 0;
                        try {
                            let soalArray = JSON.parse(data.soal || "[]");
                            if (Array.isArray(soalArray)) {
                                soalCount = soalArray.length;
                            }
                        } catch (error) {
                            console.error("Error parsing soal:", error);
                        }
                        return `<a href='/pendidik/viewevaluasi?id_ujian=${data.id_ujian}'><i class='ti ti-eye'></i><b>${soalCount}</b></a>`;
                    }
                },
                { data: "durasi" },
               
                { 
                    data: null,
                    render: function (data, type, row) {
                        return `
                        <a href="/pendidik/hasilujian?kode=${row.id_ujian}" className="avtar avtar-xs mx-1 btn-link-secondary" title='Hasil'><center>Hasil</center></a>
                           <a href="/pendidik/viewevaluasi?id_ujian=${row.id_ujian}" title='Tambah dana Lihat Soal' className="avtar avtar-xs mx-1 btn-link-secondary">
                    <i className="ti ti-eye f-20"></i>
                    </a>
                        `;
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row) {
                        return `
                            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${JSON.stringify(row)}'>
                                <i class="ti ti-edit f-20"></i>
                            </a>
                            <a href="#" class="delete-btn avtar avtar-xs mx-1 btn-link-danger" data-id="${row.id_ujian}">
                                <i class="ti ti-trash f-20"></i>
                            </a>
                             <a href="#" class="maping-btn avtar avtar-xs mx-1 btn-link-waring" data-bs-toggle="modal" data-bs-target="#myModal" data-row='${JSON.stringify(row)}'">
                                <i class="ti ti-arrows-split f-20"></i>
                            </a>
                        `;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });
      // Event DataTables setelah data Ajax diterima
      $('.table-data').on('xhr.dt', function (e, settings, json) {
        if (json && json.data) {
            setUjianList(json.data);  // Memperbarui state dengan data guru
        }
       
    });

        return () => {
            if ($.fn.dataTable.isDataTable('.table-data')) {
                $('.table-data').DataTable().destroy();
            }
        };
    }, []);// Inisialisasi ulang hanya ketika `kelas` berubah


    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    $(document).off("click", ".maping-btn").on("click", ".maping-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData.soal)
        if (rowData) {
            setSoalMaping(JSON.parse(rowData.soal));
        } else {
            console.error("Data tidak ditemukan.",rowData);
        }
    });

    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");
    
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapusujian`, {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                    body: JSON.stringify({ id_ujian : id })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                        $('.table-data').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                    } else {
                        Swal.fire("Gagal!", data.message, "error");
                    }
                })
                .catch(error => {
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                });
            }
        });
    });

    useEffect(() => {
        if (formData.id_mapel) {
            // Ambil semua pembelajaran yang sesuai dengan mapel yang dipilih
            const pembelajaranFiltered = pembelajaran?.filter(
                (item) => item.mata_pelajaran_id === formData.id_mapel
            );

            // Ambil semua rombel yang sesuai dengan pembelajaran tersebut
            const rombelIds = pembelajaranFiltered.map((item) => item.mata_pelajaran_id);
            const rombelFiltered = pembelajaran?.filter((rombel) =>
                rombelIds.includes(rombel.mata_pelajaran_id)
            );
            console.log(rombelFiltered)

          
        } 
    }, [formData.id_mapel]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Jika select option yang berubah, simpan juga nama yang dipilih
        if (name === "id_rombel") {
            const selectedRombel =pembelajaran?.find((r) => String(r.rombongan_belajar_id) ===  String(value));
            
            setFormData({
                ...formData,
                id_rombel: value,
                nama_rombel: selectedRombel ? selectedRombel.nama_rombel : "",
                pembelajaran_id: selectedRombel ? selectedRombel.pembelajaran_id : ""
            });
        } else if (name === "id_mapel") {
            const selectedMapel = pembelajaran?.find((m) => String(m.mata_pelajaran_id) ===  String(value));
            setFormData({
                ...formData,
                id_mapel: value,
                nama_mapel: selectedMapel ? selectedMapel.nama_mapel : "",
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        console.log(formData)
        
    };

    // Buka modal untuk edit data
    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
        console.log(ujian)
    };

    // Reset form untuk tambah data baru
    const handleNew = () => {
        setIsEditing(false);
        setFormData({
            kode_mst:id,
            id_ujian: "",
            id_rombel: "",
            id_mapel: "",
            nama_mapel: "",
            nama_rombel: "",
            durasi: "",
            guru_id: "",
            nama_guru: "",
            status_hasil_guru:"1",
            pembelajaran_id:""
        });
    };
   
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData,localStorage.getItem('token'))

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/inputUjian`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan data");
            }

            const result = await response.json();
            Swal.fire("Berhasil!", result.message, "success").then(() => {
                $('.table-data').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
            });

            
        } catch (error) {
             Swal.fire("Error!", error.response?.data?.message || 'Something went wrong', "error");
           
           
        }
    };

    const handleChangeSelectedRombel = (selectedOptions,name,text) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;
       
        setFormData((prevData) => ({
            ...prevData,
           
            id_mapel:"",
            nama_mapel:"",
            guru_id:"",
            nama_guru:"",
            pembelajaran_id:"",
            [name]: selectedData ? selectedData.rombongan_belajar_id : null, // Perbaiki agar langsung pakai `selectedData`
            [text]: selectedData ? selectedData.nama_rombel : null
        }));

        console.log("Updated Form Data:", formData);
    };
        
    const handleChangeSelectedMapel = (selectedOptions,name,text) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
        
            guru_id:"",
            nama_guru:"",
            pembelajaran_id:"",
            [name]: selectedData ? selectedData.mata_pelajaran_id : null, // Perbaiki agar langsung pakai `selectedData`
            [text]: selectedData ? selectedData.nama_mapel : null
        }));

        console.log("Updated Form Data:", formData);
    }; 

    const handleChangeSelectedGuru = (selectedOptions,name,text) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
            guru_id: selectedData ? selectedData.guru_id : null,
            pembelajaran_id: selectedData ? selectedData.pembelajaran_id : null, // Perbaiki agar langsung pakai `selectedData`
            nama_guru: selectedData ? selectedData.nama_guru : null,

        }));

        console.log("Updated Form Data:", formData);
    }; 


    
    const handleMaping = async (pembelajaranparm) => {
        console.log(soalmaping)
        if (!soalmaping || soalmaping.length === 0) {
            return;
        }
    
        if (!pembelajaran) {
            return;
        }
    
        try {
            // Tampilkan Swal loading sebelum memulai proses
            Swal.fire({
                title: "Memproses...",
                html: "Mohon tunggu, sedang menyimpan data...",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
    
            let successCount = 0;
            let totalData = pembelajaranparm.length;
    
            for (const idp of pembelajaranparm) {
                console.log({id_ujian:idp,soal:soalmaping})
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/mapingUjian`, {
                    method: "POST",
                   headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
                    body: JSON.stringify({id_ujian:idp,soal:soalmaping}),
                });
    
                if (!response.ok) {
                    throw new Error("Gagal menyimpan data");
                }
    
                const result = await response.json();
                successCount++;
    
                // Update progress Swal
                Swal.update({
                    html: `Sedang memproses ${successCount} dari ${totalData} data...`
                });
            }
    
            // Jika semua berhasil
            Swal.fire({
                icon: "success",
                title: "Berhasil!",
                text: "Semua data telah berhasil disimpan!",
            }).then(() => {
                $('.table-data').DataTable().ajax.reload(null, false); // Reload DataTable setelah sukses
            });
    
        } catch (error) {
            console.error("Error:", error);
            Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: "Terjadi kesalahan saat menyimpan soal!",
            });
        }
    };
    


    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Refrensi</small><h3>Evaluasi / Ujian</h3></div>

                                        <div className='col-auto'>
                                            <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button></div>
                                    </div>
                                    <hr />
                                   <table className="table table-data table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th scope="col">Kode</th>
                                                <th scope="col">Mapel / Kelas</th>
                                                <th scope="col">Guru</th>
                                                <th width="50"><center>Lihat dan Tambah Soal</center></th>
                                                <th width="50"><center>Durasi</center></th>
                                                <th width="50"><center> Hasil</center></th>
                                                
                                                <th width="50"><center>Action</center></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                           
                                        </tbody>
                                    </table>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Input/Edit */}
            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {isEditing ? "Edit Pembelajaran" : "Tambah Pembelajaran"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            {/* Pilihan Mapel */}
                         
                            <div className="mb-3">
                                <label className="form-label">Rombel / Rombongan Belajar</label>
                                <Select
                                        options={Array.from(new Map(pembelajaran?.map(item => [item.rombongan_belajar_id, item])).values()) || []}
                                        required
                                        name="id_rombel"
                                        getOptionLabel={(e) => e.nama_rombel} // Menampilkan nama di dropdown
                                        getOptionValue={(e) => e.rombongan_belajar_id} // Menggunakan id_rombel sebagai value
                                        value={pembelajaran?.find((option) => option.rombongan_belajar_id?.toString() === formData?.id_rombel?.toString()) || null}
                                        onChange={(selectedOption) => handleChangeSelectedRombel(selectedOption, "id_rombel", "nama_rombel")}
                                        placeholder="Pilih Kelas / Rombel..."
                                    />
                                </div>

                            {/* Pilihan Rombel yang difilter berdasarkan Mapel */}
                            <div className="mb-3">
                                <label className="form-label">Mepal / Mata Pelajaran</label>
                                <Select
                                        options={Array.from(
                                            new Map(
                                                pembelajaran
                                                    ?.filter(item => item.rombongan_belajar_id.toString() === formData?.id_rombel.toString()) // Filter berdasarkan mata_pelajaran_id
                                                    .map(item => [item.mata_pelajaran_id, item]) // Gunakan rombongan_belajar_id sebagai kunci unik
                                            ).values()
                                        ) || []}
                                        required
                                        name="id_mapel"
                                        getOptionLabel={(e) => e.nama_mapel} // Menampilkan nama di dropdown
                                        getOptionValue={(e) => e.mata_pelajaran_id} // Menggunakan rombongan_belajar_id sebagai value
                                        value={pembelajaran?.find(
                                            (option) => option.mata_pelajaran_id?.toString() === formData?.id_mapel?.toString()
                                        ) || null}
                                        onChange={(selectedOption) => handleChangeSelectedMapel(selectedOption, "id_mapel", "nama_mapel")}
                                        placeholder="Pilih Kelas / Rombel..."
                                    />

                            </div>

                            <div className="mb-3">
                                <label className="form-label">Guru</label>
                                <Select
                                        options={pembelajaran?.filter(item => 
                                            item.rombongan_belajar_id.toString() === formData?.id_rombel.toString() && 
                                            item.mata_pelajaran_id.toString() === formData?.id_mapel.toString()
                                        ) || []}
                                        required
                                        name="pembelajaran_id"
                                        getOptionLabel={(e) => e.nama_guru} // Menampilkan nama di dropdown
                                        getOptionValue={(e) => e.pembelajaran_id} // Menggunakan rombongan_belajar_id sebagai value
                                        value={pembelajaran?.find(
                                            (option) => option.pembelajaran_id?.toString() === formData?.pembelajaran_id?.toString()
                                        ) || null}
                                        onChange={(selectedOption) => handleChangeSelectedGuru(selectedOption, "pembelajaran_id", "nama_guru")}
                                        placeholder="Pilih Kelas / Rombel..."
                                    />

                            </div>


                            <div className="mb-3">
                                <label className="form-label">Durasi Tes</label>
                                <input name='durasi' className="form-control" type="number" placeholder="Durasi" value={formData.durasi} onChange={handleChange} />
                            </div>
                            <div className="mb-3">
                                    <label className="form-label">Tampilkan Hasil Ke Guru</label><br/>
                                    
                                    <input 
                                        checked={formData?.status_hasil_guru?.toString() === "1"} 
                                        className="form-check-input" 
                                        type="checkbox" 
                                        name="status_hasil_guru"
                                        onChange={(e) => handleChange({
                                            target: { name: "status_hasil_guru", value: e.target.checked ? "1" : "0" }
                                        })}  
                                        value={formData?.status_hasil_guru}  
                                        id="flexCheckChecked"  
                                    />

                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                        Tampilkan
                                    </label>
                                </div>

                            
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div className="modal fade" id="myModal" >
                <div className="modal-dialog  modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Maping Soal</h5>
                            <button type="button" className="btn-close" id='btn-closemaping' data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <Mapping onSave={handleMaping} soal={soalmaping} data={ujianlist}/>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default DaftarTesGuru;
